import { render, staticRenderFns } from "./ResearcherMyCollection.vue?vue&type=template&id=991d8bb4"
import script from "./ResearcherMyCollection.vue?vue&type=script&lang=js"
export * from "./ResearcherMyCollection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports